import { render } from "./ScCallTable.vue?vue&type=template&id=18e3e05b"
import script from "./ScCallTable.vue?vue&type=script&lang=js"
export * from "./ScCallTable.vue?vue&type=script&lang=js"

import "./ScCallTable.vue?vue&type=style&index=0&id=18e3e05b&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/testnet.onegate/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__